<template>
  <el-dialog 
    title="Selecionar Fabricante" 
    :visible.sync="dialogFormVisible" 
    :show-close="false"
    :close-on-click-modal="false"    
  >
    <el-form ref="form" :model="fabricante" label-width="120px">
        <el-form-item label="Fabricante" style="text-align: left">
          <el-select
            v-model="fabricante.fabricante_selecionado"
            filterable
            placeholder="Informe o Fabricante"
            style="width: 100%;"
          >
            <el-option
              v-for="item in listaFabricanteSelecionados"
              :key="item.id_fabricante"
              :label="item.fabricante.razao_social"
              :value="item.id_fabricante"
            ></el-option>
          </el-select>
        </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="logout">Sair</el-button>
      <el-button type="primary" @click="selecionarClienteFabricante(1, fabricante.fabricante_selecionado)">Selecionar</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import axios from 'axios';
  import FuncoesUteis from "../plugins/FuncoesUteis";

  // const url = 'http://'+window.location.hostname+':8000/api';
  // const url = 'https://app-laravel:8000/api';
  const url = '/api';


  export default {
    props: {
      titulo: String,
      mensagem: String,
    },
    data(){
    return {
      loading: true,
      dialogFormVisible: false,
      fabricante: {
        fabricante_selecionado: null,
      },
      listaFabricanteSelecionados: [],
      permissao: {}
    }
  },
  mounted(){
    this.permissao = FuncoesUteis.isPermissao();
  },
    methods: {
      definirClienteSgeAdministrador() {
        const token = localStorage.getItem("token");
        try {
          const payload = JSON.parse(atob(token.split(".")[1]));
          const usuario = payload.sub || 0;
          this.dialogFormVisible = true
          this.buscarClienteFabricante(usuario);
        } catch (error) {
          console.error("Erro ao decodificar o token:", error);
        }
      },
      async selecionarClienteFabricante(tipoUsuario, fabricante_selecionado) {
        try {
          let fabricante = this.listaFabricanteSelecionados.find(c => c.id_fabricante == fabricante_selecionado)
          localStorage.setItem("fabricante_nome", fabricante.fabricante.razao_social);
          localStorage.setItem("ultimo_fabricante", fabricante_selecionado);
          const response = await axios.post(url + "/select-fabricante/", { id_fabricante: fabricante_selecionado }, {
            headers: { Authorization: "Bearer " + this.$store.state.token },
          });
          if (response.data.status == "Token is Expired" || response.data.status == "Token is Invalid" || response.data.status == "Authorization Token not found") {
            await this.$store.dispatch("logout");
            this.$router.push("/login");
          } else {
            localStorage.setItem("token", response.data.new_token);
          }
          this.dialogFormVisible = false;
          window.location.reload();
          this.$message({
            type: "success",
            message: "Fabricante alterado com sucesso!",
          });
        } catch(error) {
            const errorMessage = error.response?.data?.message || "Erro inesperado ao alterar fabricante.";
            this.$message({
              type: "error",
              message: errorMessage,
            });
        }
      },
      async buscarClienteFabricante(usuario) {
        this.loading = true;
        try {
          const resp = await axios.get(url + "/users-fabricantes/user/"+usuario, {
            headers: {Authorization: "Bearer " + this.$store.state.token},
          });
          this.listaFabricanteSelecionados = resp.data;
          const idUltimoFabricante = Number(localStorage.getItem("ultimo_fabricante"));
          const encontrado = this.listaFabricanteSelecionados.find(
            item => item.id_fabricante === idUltimoFabricante
          );
          if (encontrado) {
            this.fabricante.fabricante_selecionado = encontrado.id_fabricante;
          } else {
            this.fabricante.fabricante_selecionado = null;
          }
        } catch (err) {
          if (err.response && err.response.status === 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.$notify.error({
              title: "Erro",
              message: "Erro ao buscar fabricantes relacionados! " + (err.response?.data?.message || err.message),
            });
          }
        } finally {
          this.loading = false;
        }
      },
      logout: function () {
        this.dialogFormVisible = false;
        this.$store.dispatch("logout").then(() => {
        this.$router.push("/login");
      });
    },
    }
  };
</script>
